import React from 'react';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';
import { DeleteIcon, EditIconBlue } from 'assets/icons';
import LineItemPlusReactIcon from 'assets/react-icons/LineItemPlusReactIcon';
import { CustomSwitch } from 'components';

interface TermsAndConditionsSectionProps {
  editTnc: boolean;
  tnc: {
    enabled: boolean;
    tnc: string;
  };
  toggleTerms: () => void;
  handlEditTermsClick: () => void;
  handlDeleteTermsClick: () => void;
  handlAddTermsClick: () => void;
  texts: {
    title: string;
    switchLabel: string;
    emptyStateDescription: string;
    addButtonText: string;
  };
}

const TermsAndConditionsSection = ({
  editTnc,
  tnc,
  toggleTerms,
  handlEditTermsClick,
  handlDeleteTermsClick,
  handlAddTermsClick,
  texts
}: TermsAndConditionsSectionProps) => {
  return (
    <div
      className={twMerge(
        'mt-8 mb-7 w-[90%]',
        classnames({
          'pointer-events-none opacity-50': !editTnc
        })
      )}>
      <div className="mt-9 mb-8 text-xl font-bold text-primaryText">{texts.title}</div>
      <div className="flex items-center">
        <CustomSwitch enabled={tnc?.enabled} toggleSwitch={toggleTerms} id="tnc-switch" />
        <div
          className={twMerge(
            'ml-5 text-primaryText text-[17px] font-semibold',
            classnames({
              'text-gray-1': !tnc?.enabled
            })
          )}>
          {texts.switchLabel}
        </div>
      </div>
      {tnc && tnc.tnc ? (
        <div className="mt-7 rounded-md border border-borderGray py-10 px-5">
          <div className="flex items-center justify-end">
            <div className="flex items-center">
              <div
                className="flex cursor-pointer items-center text-17px font-semibold text-secondary"
                role="presentation"
                onClick={handlEditTermsClick}>
                <EditIconBlue />
                <div className="ml-1">Edit</div>
              </div>
              <div
                className="ml-[30px] flex cursor-pointer items-center text-17px font-semibold text-primaryText"
                role="presentation"
                onClick={handlDeleteTermsClick}>
                <DeleteIcon />
                <div className="ml-1">Delete</div>
              </div>
            </div>
          </div>
          <div
            className="customNormalScroll mt-6 max-h-[160px] overflow-y-auto
                       whitespace-pre-line break-words text-sbase font-normal text-primaryText">
            {tnc.tnc}
          </div>
        </div>
      ) : (
        <>
          <div className="mt-7 text-sbase font-normal text-primaryText">{texts.emptyStateDescription}</div>
          <div className="mt-5 flex cursor-pointer items-center" role="presentation" onClick={handlAddTermsClick}>
            <LineItemPlusReactIcon id="discount-tips-add-text" />
            <div className="ml-2 text-17px font-semibold text-secondary">{texts.addButtonText}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default TermsAndConditionsSection;
